(function() { window.GUID_98991323_b94d_4052_9c6e_4e7158262ba3 = { getGuid: function() { return "98991323-b94d-4052-9c6e-4e7158262ba3"; } }; })();
var EditEncounterOpp;
(function (EditEncounterOpp) {
    var desktop;
    (function (desktop) {
        CS.FormReady(function (formId) {
            if (formId == "EditSchedules") {
                if (document.HomeId != undefined) {
                    document.HomeId.SelectionChange = function () {
                        if (this.SelectedItem != null) {
                            $('#PlaceId').control().SetValue({ value: this.SelectedItem.value.placeId });
                        }
                    };
                }
                /* en changeant de bracket, on vide les noms des équipes car ils ne seront pas dispo dans le drop down.
    
                 * #############################################################*/
                //$("#FlowBlockId").controlIsLoaded<CompuSport.Controls.DropDown>(function (dropdown) {
                //    dropdown.$DropDown.on('change', function (dropdown) {                  
                //        $('#HomeId').control<CompuSport.Controls.AutoComplete>().ClearValue();
                //        $('#AwayId').control<CompuSport.Controls.AutoComplete>().ClearValue();
                //    });
                //});
            }
        });
    })(desktop = EditEncounterOpp.desktop || (EditEncounterOpp.desktop = {}));
})(EditEncounterOpp || (EditEncounterOpp = {}));

//# sourceMappingURL=EditEncounterOpp.desktop.js.map
